export const LicenseTypesEnum = Object.freeze({
  AUTO: 'auto',
  SCOOTER: 'scooter',
  MOTOR: 'motor'
});